
export default {
  meta: {
    seo: {
      title: 'siteName',
      description: 'metaTitle'
    }
  },
  data() {
    return {
      slides: null
    }
  },
  async fetch() {
    const { $content, $i18n: { locale } } = this
    this.slides = await $content(locale, 'shop/slides')
      .sortBy('order')
      .fetch()
  }
}
